import { useTaskDescriptionGuardStore } from '@/store/task-description-guard.store'
import { UnsavedDescriptionDialog } from './UnsavedDescriptionDialog'

/**
 * App-level dialog for the task-switch guard. Mounted once (outside any panel,
 * since switching remounts the panel) and driven by the shared guard store.
 */
export function TaskDescriptionSwitchGuard() {
  const open = useTaskDescriptionGuardStore(s => s.open)
  const saving = useTaskDescriptionGuardStore(s => s.saving)
  const keepEditing = useTaskDescriptionGuardStore(s => s.keepEditing)
  const discard = useTaskDescriptionGuardStore(s => s.discard)
  const saveAndProceed = useTaskDescriptionGuardStore(s => s.saveAndProceed)

  return (
    <UnsavedDescriptionDialog
      open={open}
      onKeepEditing={keepEditing}
      onDiscard={discard}
      onSaveAndClose={saveAndProceed}
      isSaving={saving}
    />
  )
}
